import Vue from 'vue';
import debug, { debugEnabled } from './Debug';

const ES = new Vue();

const EventSystem = {
  $emit (...args) {
    debug('$emit', () => {
      console.log(`%c[ $emit ]%c (${args[0]})%c`, 'background-color: black; color: white', 'color: red', 'reset', [...args].splice(1));
    });
    ES.$emit(...args);
  },
  $on (...args) {
    debug('$on', () => {
      console.log(`%c[ Register $on ]%c (${args[0]})%c`, 'background-color: black; color: white', 'color: blue', 'reset', [...args].splice(1));
    });
    ES.$on(...args);
  },
};

document.addEventListener('keyup', (evt) => {
  if (evt.which === 27) EventSystem.$emit('keypress-esc');
});

if (debugEnabled) {
  window.$ES = EventSystem;
}

export default EventSystem;



// WEBPACK FOOTER //
// ./assets/js/source/utils/EventSystem.js